import React from "react";

const palette = {
    yellow: '#FFBC43',
    yellow10: '#FFBC4319',
    red: '#F5634B',
    red10: '#F5634B19',
    pink: '#FF326E',
    pink10: '#FF326E19',
    darkBlue: '#0D5ADA',
    darkBlue10: '#0D5ADA19',
    blue: '#3DB6FB',
    blue10: '#3DB6FB19',
    green: '#13DBB5',
    green10: '#13DBB519',
}

const getOverlayColors = initials => {
    const key = (initials || 'a').toUpperCase().substring(0, 1)
    if (key < 'E') {
        return { txtColor: palette.yellow, bgColor: palette.yellow10 }
    } else if (key < 'I') {
        return { txtColor: palette.red, bgColor: palette.red10 }
    } else if (key < 'M') {
        return { txtColor: palette.pink, bgColor: palette.pink10 }
    } else if (key < 'Q') {
        return { txtColor: palette.darkBlue, bgColor: palette.darkBlue10 }
    } else if (key < 'U') {
        return { txtColor: palette.blue, bgColor: palette.blue10 }
    } else {
        return { txtColor: palette.green, bgColor: palette.green10 }
    }
}

// forMap is if the marker should be on the map, otherwise it's for the callout
export const UserMarker = ({ text, name, onTap, forMap }) => {
    //const initials = name.split(" ").map((n)=>n[0]).join("")

    const initialArray = name ? name.split(" ").map((n)=>n[0]) : ["", ""]
    const initials = initialArray[0] + initialArray[1]
    const { txtColor, bgColor } = getOverlayColors(text)
    return (
            <div
                onClick={() => onTap(name)}
                style={{
                    width: forMap ? "50px": "11vmax",
                    height: forMap ? "50px" : "11vmax",
                    color: txtColor,
                    background: bgColor,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontFamily: "proxima-nova, sans-serif",
                    fontWeight: 400,
                    fontStyle: "normal",
                }}
            >
                <h1>{initials}</h1>
            </div>
    )
}

export const ClusterMarker = ({ text }) => (
    <div
        style={{
            width: "45px",
            height: "45px",
            color: "#fff",
            background: "#FFBC4366",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}
    >
        <div
            style={{
                width: "30px",
                height: "30px",
                color: "#fff",
                background: "#FFBC43CC",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {text}
        </div>
    </div>
)
